<script>

    import { RefundStore } from '../stores'

    import NumeralMethods from '../$methods/numeral.methods'
    import DateMethods from '../$methods/date.methods'
    import EnumMethods from '../$methods/enum.methods'

    import Value from '../$components/value.svelte'

</script>

{#if $RefundStore}
    <div class="columns">
        <div class="column">
            <Value label="Estatus" value={ EnumMethods.get($RefundStore.status) } />
        </div>
        <div class="column">
            <Value label="Método" value={ EnumMethods.get($RefundStore.method) } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Monto" value={ NumeralMethods.cash($RefundStore.amount) } />
        </div>
        <div class="column">
            <Value label="Concepto" value={ $RefundStore.concept } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Detalles" value={ $RefundStore.details } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Fecha de registro" value={ DateMethods.dateTimeLarge($RefundStore.created) } />
        </div>
    </div>
{/if}